'use strict';

import Model from './model.js';
import Company from './company.js';
import User from './user.js';
import Payroll from './payroll.js';

export const consts = {
    OPERATION_CREATE: 0,
    OPERATION_UPDATE: 1,
    OPERATION_DELETE: 2
};

export default class ChangeLog extends Model {
    urlRoot() { return '/ChangeLogs'; }

    constraints() {
        return {
            companyId: {presence: true},
            userName: {presence: true},
            changeTime:  {presence: true}
        };
    }

    initialize() {
        super.initialize(...arguments);
        this.user = null;
        this.employee = null;
        this.payroll = null;
        return this;
    }

    fetchCompany() {
        const company = new Company({objectId: this.get('companyId')});
        return company.fetch();
    }

    fetchUser() {
        if (this.user) {
            Promise.resolve(this.user);
        }

        if (!this.get('userId')) {
            return Promise.resolve(null);
        }

        return new User({id: this.get('userId')})
            .fetch()
            .then(model => {
                this.user = model;
                return this.user;
            })
            .catch(() => null);
    }

    fetchPayroll() {
        if (this.payroll) {
            Promise.resolve(this.payroll);
        }

        if (!this.get('payrollId')) {
            return Promise.resolve(null);
        }

        return new Payroll({objectId: this.get('payrollId')})
            .fetch()
            .then(model => {
                this.payroll = model;
                return this.payroll;
            })
            .catch(() => null);
    }
}



// WEBPACK FOOTER //
// ./app/new-models/change-log.js